export default __webpack_public_path__ + "static/Tripadvisor_CaseStudy_Title-Video-9c42effe6a8f78c6f42bd53748d20120.webp";